// removed by extract-text-webpack-plugin
module.exports = {"activeGoalContainer":"activeGoalContainer-18NmB","goalDescription":"goalDescription-1bLrk","goalTarget":"goalTarget-3wH49","percentCompleteContainer":"percentCompleteContainer-kvPWo","percentComplete":"percentComplete-1WgFf","progressBar":"progressBar-3rVov","progressBarFill":"progressBarFill-1vX0a","showDetails":"showDetails-3tMJL","totalTimeContainer":"totalTimeContainer-3poMy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/goals/view/_activeGoal.css
// module id = 1202
// module chunks = 1